<template>
    <div class="container" ref="container">
        <div class="lines-container">
            <div v-for="line in lines">
                <span class="ordinal">{{ line.ordinal }}</span> <span class="left" :style="{ color: line.colour }">{{ line.left }}</span> {{ line.right }}
            </div>
        </div>
    </div>
</template>

<script>
import * as nodes from "@/nodes";

export default {
    props: {
        lines: { type: Array }
    },
    watch: {
        lines() {
            this.$nextTick(() => this.$refs.container.scrollTo(0, this.$refs.container.scrollHeight));
        }
    }
}
</script>

<style lang="less" scoped>
.container
{
    width: 400px;
    overflow: auto;
}
.error
{
    padding: 8px;
    background-color: red;
    color: white;
}
.lines-container
{
    padding: 10px;
    font-size: 16px;
}
.ordinal
{
    font-size: 12px;
}
.left
{
    font-weight: bold;
}
</style>
